// Light or dark is each person's own, kept in this browser: the toggle by Sign out.
// Until they choose, the workspace's stored setting (settings.theme) applies. Not in
// App.js's LS_KEYS on purpose: those are workspace data, and sign out clears them.
const KEY = "bd:themeChoice";

export function readThemeChoice() {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "";
  } catch {
    return "";
  }
}

export function saveThemeChoice(theme) {
  try {
    localStorage.setItem(KEY, theme);
  } catch {}
}

export const shownTheme = (choice, workspaceTheme) => choice || workspaceTheme || "dark";

export const otherTheme = (theme) => (theme === "light" ? "dark" : "light");
